"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _ViewAllFeatures = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/ViewAllFeatures"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _HubToGaMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/HubToGaMap"));

// wrapper around edition-specific view all features component.
// should only be rendered after merch endpoint is returned
var ViewAllFeaturesLoadWrapper = function ViewAllFeaturesLoadWrapper(_ref) {
  var products = _ref.products,
      hub = _ref.hub,
      merchandiseId = _ref.merchandiseId,
      use = _ref.use;
  var edition = products[merchandiseId].edition;
  var gaClassName = (0, _publicPageUrls.getGAClassName)("" + _HubToGaMap.default[hub] + edition + "-pricing-features");
  return _react.default.createElement(_ViewAllFeatures.default, {
    hub: hub,
    edition: edition,
    gaClassName: gaClassName,
    use: use
  });
};

ViewAllFeaturesLoadWrapper.propTypes = {
  products: _propTypes.default.object.isRequired,
  hub: _propTypes.default.string.isRequired,
  merchandiseId: _propTypes.default.number.isRequired,
  use: _propTypes.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(ViewAllFeaturesLoadWrapper);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/ViewAllFeaturesLoadWrapper.js
// module id = 835
// module chunks = 5 6